// Theme: light | dark. Persisted in localStorage, applied as a `data-theme`
// attribute on <html>. Dark is the default — the near-black palette is the
// canonical look; light (warm cream) is opt-in via the header toggle.

export type Theme = "light" | "dark";

const STORAGE_KEY = "cinedb.theme";
const THEME_EVENT = "cinedb:theme-change";

export function getStoredTheme(): Theme {
  if (typeof window === "undefined") return "dark";
  const raw = window.localStorage.getItem(STORAGE_KEY);
  return raw === "light" ? "light" : "dark";
}

export function setStoredTheme(theme: Theme): void {
  window.localStorage.setItem(STORAGE_KEY, theme);
  applyTheme(theme);
  window.dispatchEvent(new CustomEvent<Theme>(THEME_EVENT, { detail: theme }));
}

export function applyTheme(theme: Theme): void {
  if (typeof document === "undefined") return;
  document.documentElement.setAttribute("data-theme", theme);
}

export function onStoredThemeChange(handler: (theme: Theme) => void): () => void {
  if (typeof window === "undefined") return () => {};
  const listener = (e: Event) => handler((e as CustomEvent<Theme>).detail);
  window.addEventListener(THEME_EVENT, listener);
  return () => window.removeEventListener(THEME_EVENT, listener);
}
